import React, { useState } from 'react'
import { submitToGoogleScript } from './FormCaptcha'
import {
  WHATSAPP_FORM_URL,
  WHATSAPP_SUCCESS_MESSAGE,
  buildWhatsappFormPayload,
  isFormScriptError,
} from '../config/formScripts'

export default function Whatsapp() {
  const [email, setEmail] = useState('')
  const [feedback, setFeedback] = useState('')
  const [feedbackType, setFeedbackType] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setFeedback('')

    const trimmed = email.trim()
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setFeedbackType('error')
      setFeedback('Please enter a valid email address.')
      return
    }

    if (!WHATSAPP_FORM_URL) {
      setFeedbackType('error')
      setFeedback('Signup is not configured yet. Please use Contact Us instead.')
      return
    }

    setIsSubmitting(true)

    submitToGoogleScript(WHATSAPP_FORM_URL, buildWhatsappFormPayload(trimmed))
      .then((data) => {
        if (isFormScriptError(data)) {
          setFeedbackType('error')
          setFeedback(data)
          return
        }

        setFeedbackType('success')
        setFeedback(data || WHATSAPP_SUCCESS_MESSAGE)
        setEmail('')
        window.setTimeout(() => {
          setFeedback('')
          setFeedbackType('')
        }, 5000)
      })
      .catch(() => {
        setFeedbackType('error')
        setFeedback('Something went wrong. Please try again.')
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  return (
    <div className="newsletter newsletter-parallax" data-aos="fade-up">
      <div className="container">
        <div className="newsletter-wrapper text-center" data-aos="zoom-in" data-aos-delay="200">
          <div className="newsletter-title" data-aos="fade-down" data-aos-delay="300">
            <h2 className="heading-light">
              Join us on Whatsapp <i className="fa fa-whatsapp" aria-hidden="true" />
            </h2>
            <p className="text-white">
              Submit your email id and wait for admin to reach out.
            </p>
          </div>

          <form
            name="whatsapp-signup-form"
            className="form-inline newsletter-form"
            onSubmit={handleSubmit}
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <input
              type="email"
              className="form-control text-center form-text-light"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail Address"
              required
              disabled={isSubmitting}
              autoComplete="email"
            />
            <button type="submit" className="button bnt-theme" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Join Now'}
            </button>
          </form>

          {feedback && (
            <p
              className={`newsletter-form-feedback newsletter-form-feedback--${feedbackType}`}
              role="alert"
            >
              {feedback}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
